import gql from 'graphql-tag';

export const CREATE_MULTI_LINE_FEEDBACK_CONFIG = gql`
  mutation createMultiLineSummaryFeedbackConfig($contentSnippetSummaryId: Int!, $label: String!) {
    summaryFeedback {
      addSummaryFeedbackConfigurationRankAndNote(
        contentSnippetSummaryId: $contentSnippetSummaryId
        label: $label
        configuration: [NOTE, EDIT_NOTE]
      )
    }
  }
`;
